// @ts-check

/**
 * Request - Generic method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
export const ajax = (method, url, params, headers = {}) => new Promise((resolve, reject) => {
  const request = new XMLHttpRequest();

  request.open(method, url, true);
  if (headers) {
    const names = Object.keys(headers);
    names.forEach((name) => {
      const value = headers[name];

      request.setRequestHeader(name, value);
    });
  }

  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const resp = request.responseText;
      resolve(resp);
    } else {
      reject();
    }
  };
  request.onerror = () => reject();
  request.send(JSON.stringify(params));
});

/**
 * Request - Post
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
export const post = (url, params = undefined, headers = {}) => ajax('POST', url, params, headers);

/**
 * Request - Get
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
export const get = (url, params = undefined, headers = {}) => ajax('GET', url, params, headers);

export default { get, post };



// WEBPACK FOOTER //
// ./~/@ln/ajax/ajax.js